import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { Size } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { UserUtils, EnvironmentUtils } from 'utils'
import useLazySelector from 'hooks/useLazySelector'
import assessmentPlatformRoutes from 'modules/AssessmentPlatform/routes'
import { AccountTypes } from 'modules/Auth/types'
import { BranchWrapper, Title } from '../NavTree/NavTree.styled'

const { Typography, skeletonStyles } = common
const { ContentTrace, Translucent } = skeletonStyles

const AssessmentPlatformMenuItem = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { oceanAssessmentPlatformAvailable } =
    EnvironmentUtils.getPermissions('oceanAssessmentPlatform')
  const { type } = UserUtils.getUserAccountInfo()
  const isSpecialUser = type === AccountTypes.SpecialUser
  const { isLoading, isOffice } = useLazySelector(({ system }) => {
    const { isLoading, result } = system.customerInformation
    return {
      isLoading,
      isOffice: result?.information?.currentInstallation?.isOffice,
    }
  })

  if (isLoading)
    return (
      <Translucent opacity='0.7'>
        <BranchWrapper>
          <Title>
            <ContentTrace size={Size.Small} width='100%' color='oceanDark' />
          </Title>
        </BranchWrapper>
      </Translucent>
    )

  if (isSpecialUser && oceanAssessmentPlatformAvailable && isOffice)
    return (
      <BranchWrapper>
        <Title>
          <Typography
            variant='small'
            onClick={() => dispatch(push(assessmentPlatformRoutes.root))}
            title={t('navigation.assessmentPlatform')}
          >
            {t('navigation.assessmentPlatform')}
          </Typography>
        </Title>
      </BranchWrapper>
    )
  return null
}

export default AssessmentPlatformMenuItem
